<template>
    <div class="privacy container">
        <h2 class="title" style="text-align: center">
            Privacy Policy
        </h2>
        <p>
            This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from uptowncreative.io (the “Site”).
            <br>
            <br>
            PERSONAL INFORMATION WE COLLECT
            <br>
            <br>
            When you submit a request, contact us, make a purchase or attempt to make a purchase directly or through the Site, or through our electronic invoices, we collect certain information from you, including your name, billing address, payment information (including credit card numbers, PayPal account information, email address, and phone number), project details & requirements and more.  We refer to this information as “Personal Information.”
            <br>
            <br>
            HOW DO WE USE YOUR PERSONAL INFORMATION?
            <br>
            <br>
            We use the Personal Information that we collect generally to fulfill any orders placed directly or through the Site (including processing your payment information and providing you with invoices and/or order confirmations).  Additionally, we use this Order Information to: Communicate with you; Screen our orders for potential risk or fraud; Fulfill orders and requests; and Provide you with information or advertising relating to our products or services.
            <br>
            <br>
            SHARING YOUR PERSONAL INFORMATION
            <br>
            <br>
            We share your Personal Information with third parties to help us use your Personal Information, as described above.  For example, we use Xero to power our online accounting—you can read more about how Xero uses your Personal Information here:  https://www.xero.com/ca/about/legal/privacy/ (Canada) and https://www.xero.com/us/about/legal/privacy/ (United States).  We also use Stripe to process credit card payments—you can read more about how Stripe uses your Personal Information here: https://stripe.com/en-ca/privacy. We also share relevant details with third-party vendors who assist Uptown Creative, Inc. in servicing, building and fulfilling requests. We also use other third-party software and services to manage projects, store Personal Information and run our business efficiently. 
            <br>
            <br>
            Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.
            <br>
            <br>
            DO NOT TRACK
            <br>
            Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.
            <br>
            <br>
            YOUR RIGHTS
            <br>
            If you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below.
            <br>
            <br>
            Additionally, if you are a European resident we note that we are processing your information in order to fulfill contracts we might have with you (for example if you make an order through the Site), or otherwise to pursue our legitimate business interests listed above.  Additionally, please note that your information will be transferred outside of Europe, including to Canada and the United States.
            <br>
            <br>
            DATA RETENTION
            <br>
            When you contact us or place an order through the Site, we will retain your Personal Information until you ask us to delete this information.
            <br>
            <br>
            MINORS
            <br>
            The Site is not intended for individuals under the age of 16.
            <br>
            <br>
            CHANGES
            <br>
            We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons. We reserve the right to modify this privacy policy at any time – please review it frequently. Any clarifications and revisions posted on the website will take effect immediately.
            <br>
            <br>
            CONTACT US
            <br>
            For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at team@uptowncreative.io.
            <br>
            <br>
            Updated: October 5, 2020
        </p>
    </div>
</template>

<script>

export default {
    name: "Privacy",
}   
</script>

<style lang="scss" scoped>
.container{
    margin-top: 70px;
    margin-bottom: 70px;
}
</style>